import '@aofl/picture';
import background from './images/background.webp';
import backgroundMobile from './images/background-mobile.webp';
import loginLogo from './images/logo.webp';

export const template = (ctx, html) => html`
  <div id="content">
    <div class="card flex-md-row rounded border-0 mb-4">
      <aofl-picture id="aofl-banner">
        <aofl-source media="(max-width: 767.8px)" srcset="${backgroundMobile}" width="359" height="118"></aofl-source>
        <aofl-img src="${background}" width="645" height="550"></aofl-img>
      </aofl-picture>
      <div id="login-box" class="login-form card-body d-flex align-items-center justify-content-center text-muted pt-md-3 pb-md-4">
        <div id="login-form-box" class="w-100">
          <div class="d-flex justify-content-center flex-column mb-5 mb-md-1 mb-lg-3">
            <aofl-img class="mb-2" src="${loginLogo}" width="252" height="32"></aofl-img>
          </div>
          <slot name="content"></slot>
        </div>
      </div>
    </div>

    <slot name="footer"></slot>
  </div>
`;
